import { render, staticRenderFns } from "./pageNone.vue?vue&type=template&id=16b0503a&scoped=true"
import script from "./pageNone.vue?vue&type=script&lang=js"
export * from "./pageNone.vue?vue&type=script&lang=js"
import style0 from "./pageNone.vue?vue&type=style&index=0&id=16b0503a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0503a",
  null
  
)

export default component.exports